import { ArrowForwardRounded } from "@mui/icons-material";
import { Button } from "~/components/ui/core/Button";
import { Link } from "~/components/ui/core/Link";
import { buildFiguresUrl } from "~/lib/url";

type FilteredMuiButtonProps = Omit<typeof Button, "href" | "color" | "variant" | "endIcon">;

type Props = {
  className?: string;
  source: string;
  ButtonProps?: FilteredMuiButtonProps;
};

export const ContactButton: React.FC<Props> = ({ ButtonProps, className, source }) => {
  return (
    <Button
      component={Link}
      color="primary"
      to={buildFiguresUrl(`/signup?utm_source=${source}`)}
      className={className}
      {...ButtonProps}
      variant="contained"
      endIcon={<ArrowForwardRounded />}
    >
      Contact us
    </Button>
  );
};
